import React, { useState } from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Text, Container, Button } from "@atoms";
import { CardExpanded } from "@molecules";
import { m } from "framer-motion";

const CardExpandedGrid = ({ heading, cards }) => {
  const [showMore, setShowMore] = useState(false);

  if (cards && cards.length > 0) {
    const { romero } = brand;
    return (
      <div
        className={classNames("py-24", {
          "bg-gray-light": !romero,
          "bg-near-white": romero,
        })}
      >
        <m.div
          initial={{ height: "50vh" }}
          animate={showMore ? { height: "auto" } : { height: "50vh" }}
          className={classNames(
            "relative h-1/2-screen min-h-cards overflow-hidden"
          )}
        >
          <Container>
            <Text variant="h3" className="mb-12 text-center">
              {heading}
            </Text>
            <div className="-mx-2 flex flex-wrap lg:-mx-3">
              {cards
                .filter(card => card.url)
                .map(card => {
                  return (
                    <div className="mb-4 w-full px-2 sm:w-1/2 lg:mb-6 lg:w-1/3 lg:px-3">
                      <CardExpanded {...card} />
                    </div>
                  );
                })}
            </div>
            {cards.length > 3 && (
              <div
                className={classNames(
                  "absolute bottom-0 left-0 right-0 z-10 flex h-64 items-center justify-center pb-6 transition duration-200",
                  {
                    "bg-gradient-to-b from-transparent to-gray-light": !romero,
                    "bg-gradient-to-b from-transparent to-white": romero,
                    "pointer-events-none translate-y-1/4 opacity-0": showMore,
                  }
                )}
              >
                <div className={classNames("mt-auto ", {})}>
                  <Button
                    onClick={() => setShowMore(true)}
                    rounded={romero}
                    color={romero ? "blue" : "red"}
                  >
                    Show More
                  </Button>
                </div>
              </div>
            )}
          </Container>
        </m.div>
      </div>
    );
  }
  return null;
};

CardExpandedGrid.defaultProps = {};

export default CardExpandedGrid;
